import { NoteDetailsStrings } from './NoteDetailsStrings';
import { NoteEditStrings } from './NoteEditStrings';

export const NoteStrings = {
  details: NoteDetailsStrings,
  edit: NoteEditStrings
};
